<template>
  <div>
    <header class="header-section">
      <v-app-bar color="red darken-3" hide-on-scroll flat>
        <div class="d-flex align-start my-2" style="margin-left:-16px !important; width: 100px;">
          <v-img
            src="assets/images/logo_white.webp"
            transition="scale-transition"
            style="cursor: pointer;"
            class="shrink ml-2"
            :class="$vuetify.breakpoint.mobile ? 'mx-4 scaled-logo' : 'scaled-logo'"
            :height="$vuetify.breakpoint.mobile ? 46 : 54"
            contain
            @click="redirectListItem('/')"
          ></v-img>
        </div>
        <v-spacer></v-spacer>
        <v-layout row v-if="!$vuetify.breakpoint.mobile" justify-end>
          <v-btn text color="white" to="/reserva" class="pa-2 custom-title">
            {{ $t('alquilar') }}
          </v-btn>
          <v-divider dark vertical class="custom-divider"></v-divider>
          <v-btn text color="white" to="/flota" class="pa-2 custom-title">
            {{ $t('flota') }}
          </v-btn>
          <!-- comentado el 01-04-2025 por MMURILLO a pedido de Sofi -->
          <!-- <v-divider dark vertical class="custom-divider"></v-divider>
          <v-btn text color="white" to="/beneficios" class="pa-2 custom-title">
            {{ $t('menu_beneficios') }}
          </v-btn> -->
          <v-divider dark vertical class="custom-divider"></v-divider>
          <v-btn text color="white" to="/contacto" class="pa-2 custom-title">
            {{ $t('contacto') }}
          </v-btn>
          <v-divider dark vertical class="custom-divider"></v-divider>
          <v-btn text color="white" @click="openModalLenguage()" class="pa-2 custom-title">
            {{ $t('idiomas') }}
            <v-icon right dark>mdi-chevron-down</v-icon>
          </v-btn>  
        </v-layout>
        <v-app-bar-nav-icon v-else class="mr-4" dark @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-app-bar>
      <v-navigation-drawer v-if="$vuetify.breakpoint.mobile" v-model="drawer" app>
        <v-list nav>
          <v-list>
            <v-list-item @click="redirectListItem('/reserva')">
              <v-list-item-icon>
                <v-icon color="red darken-1">mdi-car-side</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ $t('alquilar') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="redirectListItem('/flota')">
              <v-list-item-icon>
                <v-icon color="red darken-1">mdi-forum</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ $t('flota') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="redirectListItem('/beneficios')">
              <v-list-item-icon>
                <v-icon color="red darken-1">mdi-gift</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ $t('menu_beneficios') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="redirectListItem('/contacto')">
              <v-list-item-icon>
                <v-icon color="red darken-1">mdi-phone</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> {{ $t('contacto') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item  @click="openModalLenguage()">
              <v-list-item-icon>
                <v-icon color="red darken-1">mdi-forum</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ $t('idiomas') }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list>
      </v-navigation-drawer>
    </header>
    <!-- Seleccion de Idioma -->
    <SelectIdioma 
      :datos="dialogLenguage"
      @setearLanguaje="changeLocale"
      @setearModalIdiomas="setModalIdiomas"
    />
  </div>
</template>

<script>
import i18n from '@/plugins/i18n'
import { VueTypedJs } from 'vue-typed-js'
import SelectIdioma from './SelectIdioma.vue'
export default {
  data() {
    return {
      drawer: false,
      dialogLenguage: {
        activo: false,
        languages: [
          { flag: 'us', language: 'en', title: 'English' },
          { flag: 'es', language: 'es', title: 'Español' }
        ]
      },
      idioma: 'Idioma',
      userLocale: null
    }
  },
  components: {
    SelectIdioma,
    VueTypedJs
  },
  created () {
    
  },
  mounted () {
    if (localStorage.getItem('radaIdioma')){
      let lang = JSON.parse(localStorage.getItem('radaIdioma'))
      i18n.locale = lang.language
      this.idioma = lang.title
    }
  },
  methods: {
    openModalLenguage() {
      this.drawer = false
      this.dialogLenguage.activo = true
    },
    setModalIdiomas(value){
      this.dialogLenguage.activo = value
    },
    changeLocale(locale_select) {
      //cambia el idioma de la pagina
      if (localStorage.getItem('radaIdioma')) localStorage.removeItem('radaIdioma')
      localStorage.setItem('radaIdioma', JSON.stringify(locale_select))
      i18n.locale = locale_select.language
      this.idioma = locale_select.title
    },
    redirectListItem(path) {
      //Redirect pages
      if (this.$route.path != path) this.$router.push(path)
    }
  },
  watch: {
    
  },
}
</script>

<style scoped>
  .custom-title {
    text-transform: none;
  }

  .custom-divider {
    background-color: white;
    height: 35px;
    width: 5px;
    margin: 0px 0px;
  }

  .scaled-logo {
    transform: scale(0.8); /* Escala al 80% del tamaño original */
    transform-origin: center; /* Mantiene la posición centrada */
  }
</style>